import { PageLayout } from "~/components/PageLayout";
import { ChangePasswordForm } from "~/features/auth/components/ChangePasswordForm";

export const ChangePasswordPage = () => {
  return (
    <PageLayout>
      <ChangePasswordForm />
    </PageLayout>
  );
};
